import api from '../api/api';

export const printTransferPdf = async (invoice) => {
  const number = invoice.invoiceNo || invoice.docNo;
  const { data } = await api.get(`/transfers/${encodeURIComponent(number)}/document.pdf`, { responseType: 'blob' });
  const url = URL.createObjectURL(data);
  const frame = document.createElement('iframe');
  frame.title = `${invoice.documentTitle || 'Invoice'} #${number}`;
  frame.style.cssText = 'position:fixed;width:1px;height:1px;right:0;bottom:0;border:0;';
  frame.onload = () => { frame.contentWindow.focus(); frame.contentWindow.print(); };
  frame.src = url;
  document.body.appendChild(frame);
  setTimeout(() => { frame.remove(); URL.revokeObjectURL(url); }, 300000);
};
